import styled, { css } from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

type StyledMedicinePackageProps = {
   readonly $valid: boolean;
};

export const StyledMedicinePackage = styled.div<StyledMedicinePackageProps>`
   ${basicSmallTextStyle};

   ${(props) =>
      !props.$valid &&
      css`
         color: ${props.theme.disabledDark};
      `}
`;

StyledMedicinePackage.displayName = 'StyledMedicinePackage';
